import { render, staticRenderFns } from "./ProjectConfigurationPeople.vue?vue&type=template&id=e37ba34c&scoped=true&"
import script from "./ProjectConfigurationPeople.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationPeople.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationPeople.vue?vue&type=style&index=0&id=e37ba34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37ba34c",
  null
  
)

export default component.exports